<div [hidden]="!active" class="pane tabChildComponent">
  
  <ng-content></ng-content>
    <ng-container *ngIf="template"
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{ data: dataContext }"
    >
    </ng-container>
    
  </div>